import Component from '../core/Component'
import $ from 'jquery'

const STATES = {
    OPEN: 'is-active'
}

export default class Nav extends Component {
    constructor($element) {
        super($element)

        this.$items = this.$element.find('[data-ref=item]')
        this.$container = this.$element.find('[data-ref=container]')
        this.$fixed = this.$element.find('[data-ref=fixed]')
        this.$window = $(window)
        this.$toggle = this.$element.find('[data-ref=toggle]')
    }

    prepare() {
        this.$window.resize(::this.resize)

        this.$toggle.click(this.click)

        this.resize()
    }

    click() {
        event.preventDefault();
    }

    resize() {
        let elementWidth = this.$element.width()
        let $container = this.$container
        let $fixed = this.$fixed.first()

        this.$fixed.each(function() {
            elementWidth -= $(this).outerWidth(true)
        });

        let itemWidth = 0
        let mobile = ($(window).innerWidth() < 768) ? true : false;

        this.$items.each(function(item) {
            if (!mobile) {
                itemWidth += $(this).outerWidth(true)

                if (itemWidth > elementWidth - 40) {
                    if (!$(this).parent().hasClass('nav__sub')) {
                        $(this).prependTo($container)
                    }
                } else {
                    if ($(this).parent().hasClass('nav__sub')) {
                        $(this).insertBefore($fixed)
                    }
                }
            } else {
                $(this).insertBefore($fixed)
            }
        });

        if ($container.find("li").length < 1) {
            this.$fixed.last().addClass('is-hidden')
        } else {
            this.$fixed.last().removeClass('is-hidden')
        }
    }
}


// WEBPACK FOOTER //
// ./components/Nav.js